import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import "./NavigationLink.scss";
import { cleanJoin } from "../../../utils/stringUtil";
import { ThemeContext } from "../../../common/theme/ThemeContext";

function NavigationLink({ label, className, ...rest }) {
  const theme = useContext(ThemeContext);
  return (
    <NavLink
      style={{ color: theme.navLinkColor }}
      activeClassName={`navigation-link-active-${theme.themeColor}`}
      className={cleanJoin(
        "navbar-item",
        `navigation-link-${theme.themeColor}`,
        `has-background-${theme.lineColor}`,
        className
      )}
      {...rest}
    >
      {label}
    </NavLink>
  );
}

export default NavigationLink;
